module.exports = __webpack_public_path__ + "img/fengmian.292c3cca.png";